import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Features, ModuleNames } from '../../../common/model/account-definition';
import { UserAccountService } from '../../../common/service/user-account.service';
import { FormComponentBase } from '../../../core/component/forms/form-component.base';
import { SelectionItem } from '../../../core/component/select/select.component';
import { standardCommand } from '../../../core/model/command';
import { DataService } from '../../../core/service/base/data.service';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { DeleteFormCommandHandler } from '../../../core/service/command/delete-form-command-handler.service';
import { FormCommandHandlerResolver } from '../../../core/service/command/form-command-handler-resolver.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { MeterMediaTypeSelection } from '../../model/const/enums';
import { MeterModel } from '../../model/meter-model';
import { MeterModelService } from '../../service/meter-type.service';

@Component({
    selector: 'app-imd-meter-model-form',
    templateUrl: './meter-model-form.component.html',
    styleUrls: ['./meter-model-form.component.scss'],
    providers: [DeleteFormCommandHandler, FormCommandHandlerResolver, { provide: DataService, useExisting: MeterModelService }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImdMeterModelFormComponent extends FormComponentBase<MeterModel> {
  constructor(
    private _fb: FormBuilder,
    private _fc: FormControlExFactory,
    private _accountService: UserAccountService,
    activatedRoute: ActivatedRoute,
    commandDispatcher: CommandDispatcher,
    handlerResolver: FormCommandHandlerResolver,
    _service: MeterModelService,
    messageService: MessageService,
    navigation: NavigationService
  ) {
    super(activatedRoute, _service, messageService, navigation, commandDispatcher, handlerResolver);

    this.AddSubscription(
      this._accountService.current.subscribe({
        next: account => {
          if (account.hasAccess(ModuleNames.Consumption, Features.Consumption_MeterModel_Create)) {
            this.addMenuItemDefinition('CREATE_BTN', standardCommand.create);
          }
        },
      })
    );

    this.meterTypeSelection = MeterMediaTypeSelection;
  }

  protected createModel(): MeterModel {
    return new MeterModel();
  }

  meterTypeSelection: SelectionItem[];

  protected getFormGroup(): FormGroup {
    return this._fb.group({
      id: this._fc.createHidden(this.dataContext.id),
      meterType: this._fc.createWithOptions('CONSUMPTION.MEDIA_TYPE.TYPE', this.dataContext.meterType, {
        isReadonly: !this.isNew,
        required: true,
      }),
      name: this._fc.createMandatory('CONSUMPTION.METER_MODEL.METER_MODEL', this.dataContext.name),
      manufacturer: this._fc.create('CONSUMPTION.METER_MODEL.MANUFACTURER', this.dataContext.manufacturer),
    });
  }
}
